import { vesselPolygonPoints } from '../map/vesselMarkerStyle'

/**
 * Значок судна для легенды сайдбара — тот же силуэт, что на карте.
 *
 * Геометрия берётся из `vesselMarkerStyle`, а не рисуется здесь заново: легенда
 * с кружками уже обещала значок, которого на карте нет (фидбек владельца
 * 2026-08-07), и повторять эту ошибку с «похожим» треугольником незачем.
 */
export function VesselGlyph({
  color,
  hollow = false,
  size = 11,
}: {
  color: string
  /** Курса нет — полый контур (как на карте). */
  hollow?: boolean
  size?: number
}) {
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden className="shrink-0">
      <polygon
        points={vesselPolygonPoints(size)}
        fill={hollow ? 'none' : color}
        stroke={color}
        strokeWidth={hollow ? size * 0.12 : size * 0.07}
        strokeLinejoin="round"
      />
    </svg>
  )
}
